<template>
  <div class="timer-wrapper">
    <div v-if="info">
      <div v-if="meetingInfo.roleType == 1">
        <van-tabs
          v-model="meetingInfo.timer_type"
          sticky
          color="#1890FF"
          title-active-color="#1890FF"
          :before-change="beforeChange"
        >
          <van-tab title="正计时">
            <div class="positive-wrapper owner">
              <div
                :class="
                  meetingInfo.status == 1
                    ? 'positive-time active'
                    : 'positive-time'
                "
              >
                {{ time }}
              </div>
            </div>
          </van-tab>
          <van-tab title="倒计时">
            <div class="negative-wrapper owner">
              <div class="negative-set" v-if="meetingInfo.status == 2">
                <div class="set-box">
                  <div class="setItem">
                    <input
                      type="text"
                      :value="countdownTime[0]"
                      maxlength="2"
                      @input="changeM"
                    />
                    <span>分</span>
                  </div>
                  <div class="setItem">
                    <input
                      type="text"
                      :value="countdownTime[1]"
                      maxlength="2"
                      @input="changeS"
                    />
                    <span>秒</span>
                  </div>
                </div>
                <div class="choose-box">
                  <div class="title">常用计时：</div>
                  <div class="chooseList">
                    <div
                      :class="
                        chooseIndex === index
                          ? 'choose-item active'
                          : 'choose-item'
                      "
                      v-for="(item, index) in chooseList"
                      :key="index"
                      @click="chooseTime(index)"
                    >
                      <span class="number">{{ item.score }}</span
                      >分钟
                    </div>
                  </div>
                </div>
              </div>
              <div class="negative-show" v-else>
                <van-circle
                  v-model="currentRate"
                  :rate="rate"
                  :stroke-width="80"
                  size="250px"
                  :color="
                    meetingInfo.status == 0
                      ? gradientColor[0]
                      : gradientColor[1]
                  "
                  text=""
                  layer-color="#ebedf0"
                >
                  <div class="circle-text">
                    <p
                      :class="
                        meetingInfo.status == 0 ? 'c-time' : 'c-time active'
                      "
                    >
                      {{ time }}
                    </p>
                    <p class="t-time">共{{ totalTimeText }}</p>
                  </div>
                </van-circle>
              </div>
            </div>
          </van-tab>
        </van-tabs>
        <div class="footer">
          <p class="tips">发起后，所有人打开程序都将同步展示计时</p>
          <div class="handle-btn flexCenterBetween">
            <div
              class="left"
              @click="meetingInfo.status == 2 ? back() : reSet()"
            >
              {{ meetingInfo.status == 2 ? "返回" : "重置" }}
            </div>
            <div
              :class="
                meetingInfo.status == 2 ? 'center-btn' : 'center-btn active'
              "
              @click="start()"
            >
              <img :src="statusImg[meetingInfo.status]" alt="" />{{
                meetingInfo.status == 2
                  ? "开始计时"
                  : meetingInfo.status == 1
                  ? "继续"
                  : "暂停"
              }}
            </div>
            <div
              class="right"
              @click="meetingInfo.status != 2 ? finish() : toRecord()"
            >
              {{ meetingInfo.status != 2 ? "结束" : "记录" }}
            </div>
          </div>
        </div>
      </div>

      <div v-show="meetingInfo.roleType != 1">
        <div class="user-title">计时器</div>
        <div class="negative-wrapper" v-if="meetingInfo.timer_type">
          <div class="negative-show">
            <van-circle
              v-model="currentRate"
              :rate="rate"
              :stroke-width="80"
              size="250px"
              :color="
                meetingInfo.status == 1 ? gradientColor[1] : gradientColor[0]
              "
              text=""
              layer-color="#ebedf0"
            >
              <div class="circle-text">
                <p
                  :class="meetingInfo.status == 1 ? 'c-time active' : 'c-time '"
                >
                  {{ time }}
                </p>
                <p class="t-time">共{{ totalTimeText }}</p>
              </div>
            </van-circle>
          </div>
        </div>
        <div class="positive-wrapper" v-else>
          <div
            :class="
              meetingInfo.status == 1 ? 'positive-time active' : 'positive-time'
            "
          >
            {{ time }}
          </div>
        </div>

        <div class="footer">
          <div class="handle-btn flexCenterBetween">
            <div
              :class="
                meetingInfo.status == 2
                  ? 'center-btn center-btn-single'
                  : 'center-btn center-btn-single active'
              "
              @click="meetingInfo.status == 2 ? back() : ''"
            >
              {{
                meetingInfo.status == 2
                  ? "计时结束，离开计时器"
                  : meetingInfo.status == 0
                  ? "正在计时"
                  : "计时暂停了"
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="loading-wrap" v-else>
      <van-loading type="spinner" vertical>加载中...</van-loading>
    </div>
  </div>
</template>
<script>
import {
  getToken,
  timestampToDate,
  deepClone,
  formatMinuteText,
  reLogin,
  getCurMeeetInfo,
  getUTCTime,
  backStep
} from "@/utils/common";
import questionOnly from "@/utils/questionOnly";
import { Toast, Dialog } from "vant";
let timer = null;
let finishTimer = null;
export default {
  data() {
    return {
      info: false,
      is_owner: 0,
      timeNum: 0,
      time: "00:00",
      status: 2, // 2: 未开始计时/结束 0: 计时中 1: 暂停中  ---: 0 未开始  ： 1 进行中  2： 暂停
      chooseList: [
        { time: ["01", "00"], score: 1 },
        { time: ["05", "00"], score: 5 },
        { time: ["10", "00"], score: 10 },
        { time: ["15", "00"], score: 15 }
      ],
      countdownTime: ["01", "00"],
      chooseIndex: 0,
      currentRate: 0,
      rate: 100,
      totalTimeText: "",
      gradientColor: [
        {
          "0%": "#99CEFF",
          "100%": "#1890ff"
        },
        {
          "0%": "#ccc",
          "100%": "#ccc"
        }
      ],
      meetingInfo: {
        roleType: 0,
        status: 2,
        timer_type: 0
      },
      totalTime: 60,
      userInfo: {},
      statusImg: [
        "https://cdn-xcx-qunsou.weiyoubot.cn/material/2022-10-31/a68572cc1ed37b770e5c601b1d14de15.svg",
        "https://cdn-xcx-qunsou.weiyoubot.cn/material/2022-10-31/ff5f09e5fba06a96f916a9a4c4170341.svg",
        "https://cdn-xcx-qunsou.weiyoubot.cn/material/2022-10-31/76ff51ff68dcf0467d5ee07c77eff957.svg"
      ]
    };
  },
  watch: {
    "$store.state.meetingInfo"() {
      let { status: pre_status, roleType, timer_id: pre_timer_id } = deepClone(
        this.meetingInfo
      );
      if (!roleType) {
        let {
          status,
          expend_time,
          time_limit,
          timer_type,
          timer_id
        } = this.$store.state.meetingInfo;
        if (status == 2) {
          if (finishTimer) {
            clearTimeout(finishTimer);
            finishTimer = null;
          }
          return this.clear();
        }
        this.handleMeetInfo("multiple", {
          status,
          expend_time,
          time_limit,
          timer_type,
          timer_id
        });
        if (status != pre_status || timer_id != pre_timer_id) {
          if (status == 1) {
            if (timer) {
              clearInterval(timer);
              timer = null;
            }
          }
          this.initTimer();
        }
      }
    }
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo")) || {}
    this.getTimerInfo();
    history.pushState(null, null, document.URL);
    window.addEventListener("popstate", this.disableBrowserBack);
  },
  methods: {
    disableBrowserBack() {
      if (this.meetingInfo.roleType == 1 || this.meetingInfo.status == 2) {
        this.$router.go(-1);
      } else {
        history.pushState(null, null, document.URL);
      }
    },
    initTimer() {
      let { status, time_limit, timer_type, expend_time } = this.meetingInfo;
      this.timeNum = timer_type ? time_limit - expend_time : expend_time;
      this.time = timestampToDate(this.timeNum * 1, 2);
      if (timer_type) {
        // 倒计时
        this.totalTime = time_limit;
        this.totalTimeText = formatMinuteText(time_limit);
        this.countdownTime = [
          Math.floor((time_limit / 60) % 60),
          Math.floor(time_limit % 60)
        ];
        this.chooseIndex = [60, 300, 600, 900].indexOf(
          Math.floor((time_limit / 60) % 60) * 60 + Math.floor(time_limit % 60)
        );
        if (this.chooseIndex > -1)
          this.countdownTime = this.chooseList[this.chooseIndex].time;
      }
      if (status == 0 && !timer) {
        timer = setInterval(() => {
          if (timer_type && this.timeNum == 0) {
            return this.clear();
          }
          this.time = timestampToDate(
            timer_type ? this.timeNum * 1 - 1 : this.timeNum * 1 + 1,
            2
          );
          this.timeNum = timer_type
            ? this.timeNum * 1 - 1
            : this.timeNum * 1 + 1;
          if (timer_type) {
            this.rate = ((this.timeNum * 1 - 1) / this.totalTime) * 100;
          }
        }, 1000);
      } else if (status == 1) {
        // 暂停的状态下
        if (timer_type) {
          this.rate = ((this.timeNum * 1) / this.totalTime) * 100;
        }
      }
    },
    handleMeetInfo(type, value) {
      let copyData = deepClone(this.meetingInfo);
      if (type == "multiple") {
        this.meetingInfo = { ...copyData, ...value };
      } else {
        this.meetingInfo = { ...copyData, [type]: value };
      }
    },
    async getTimerInfo() {
      let res = await getCurMeeetInfo(this.$store.state.meetingInfo.meet_id);
      if (res) {
        let {
          status = 2,
          time_limit = 60,
          timer_type = 0,
          expend_time = 0,
          tid = "",
          meet_admin
        } = res.data;
        this.handleMeetInfo("multiple", {
          status: status,
          time_limit: time_limit || 60,
          timer_type: timer_type || 0,
          expend_time: status == 2 ? 0 : expend_time,
          roleType: meet_admin && meet_admin == this.userInfo.openId ? 1 : 0,
          meet_id: this.$store.state.meetingInfo.meet_id,
          timer_id: tid
        });
        this.info = true;
        if (status != 2) this.initTimer();
      }
    },
    async start(reset = "") {
      let { timer_type, status } = this.meetingInfo;
      if (timer_type && status == 2) {
        this.totalTime = this.countdownTime[0] * 60 + this.countdownTime[1] * 1;
        this.timeNum = this.countdownTime[0] * 60 + this.countdownTime[1] * 1;
        if (!this.totalTime) {
          return Toast("请先设置倒计时时间");
        }
      }
      if (status == 0 && !reset) {
        // 如果是进行中的状态点击则变为暂停
        let res = await this.handleTimer(1);
        if (res) {
          this.handleMeetInfo("status", 1);
          clearInterval(timer);
          timer = null;
          return;
        }
      }
      if ((status == 1 || status == 2 || reset) && !timer) {
        // 暂停或者未开始则变成开始计时
        let res;
        if (status == 2 || reset) {
          // 开始一个定时器
          if (reset) {
            status = 2;
          }
          res = await this.startTimer();
        }
        if (status == 1) {
          res = await this.handleTimer(0);
        }
        if (res) {
          if (timer_type) {
            if (status == 2) {
              this.totalTimeText = formatMinuteText(this.totalTime);
              if (timer_type) {
                this.rate = 100;
                this.time = timestampToDate(this.timeNum * 1, 2);
              }
            }
          }
          status == 2
            ? this.handleMeetInfo("multiple", {
                status: 0,
                timer_id: res.data.timer_id
              })
            : this.handleMeetInfo("status", 0);
          timer = setInterval(() => {
            if (timer_type && this.timeNum == 0) {
              return this.clear();
            }
            this.time = timestampToDate(
              timer_type ? this.timeNum * 1 - 1 : this.timeNum * 1 + 1,
              2
            );
            this.timeNum = timer_type
              ? this.timeNum * 1 - 1
              : this.timeNum * 1 + 1;
            if (timer_type) {
              this.rate = ((this.timeNum * 1 - 1) / this.totalTime) * 100;
            }
          }, 1000);
        }
      }
    },
    beforeChange(e) {
      if (this.meetingInfo.status == 2) {
        if (this.timeNum && !e) {
          // 如果切换为正计时
          this.time = "00:00";
          this.timeNum = 0;
        }
        this.handleMeetInfo("timer_type", e);
        return;
      }
      Dialog.confirm({
        title: "",
        message: "正在计时中，是否需要切换计时器重新开始",
        confirmButtonColor: "#1890ff",
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(() => {
          if (!e) {
            this.time = "00:00";
          }
          this.handleMeetInfo("status", 2);
          this.clear();
          this.handleMeetInfo("timer_type", e);
        })
        .catch(() => {});
    },
    back() {
      backStep();
    },
    reSet() {
      Dialog.confirm({
        title: "",
        message: "重置后重新开始计时，是否重置",
        confirmButtonColor: "#1890ff",
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(() => {
          this.clear("reset");
        })
        .catch(() => {});
    },
    toRecord() {
      this.$router.push({ name: "timerRecord" });
    },
    async finish() {
      this.clear();
    },
    async clear(reset) {
      if (this.meetingInfo.roleType == 1) {
        await this.handleTimer(2);
      }
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
      if (!(this.meetingInfo.roleType == 1 && reset))
        this.handleMeetInfo("status", 2);
      if (this.meetingInfo.roleType == 1) {
        this.timeNum =
          reset && this.meetingInfo.timer_type ? this.totalTime : 0;
        this.time = "00:00";
        if (this.meetingInfo.timer_type) {
          this.rate = 100;
        }
      } else {
        if (!finishTimer) {
          finishTimer = setTimeout(() => {
            if (this.meetingInfo.status == 2) {
              this.$router.go(-1);
            } else {
              clearTimeout(finishTimer);
              finishTimer = null;
            }
          }, 10 * 1000);
        }
      }
      if (reset) this.start(reset);
    },
    chooseTime(index) {
      this.chooseIndex = index;
      this.countdownTime = this.chooseList[index].time;
    },
    ifMatch() {
      let time = this.countdownTime[0] * 60 + this.countdownTime[1] * 1;
      this.chooseIndex = [60, 300, 600, 900].indexOf(time);
    },
    changeM(e) {
      let copy = deepClone(this.countdownTime);
      copy[0] = e.target.value.replace(/[^\d]/g, "");
      this.countdownTime = copy;
      this.ifMatch();
    },
    changeS(e) {
      let copy = deepClone(this.countdownTime);
      copy[1] = e.target.value.replace(/[^\d]/g, "");
      this.countdownTime = copy;
      this.ifMatch();
    },
    startTimer() {
      return new Promise(resolve => {
        let data = {
          access_token: getToken(),
          open_id: this.userInfo.openId,
          meet_id: this.meetingInfo.meet_id,
          timer_type: this.meetingInfo.timer_type,
          time_limit: this.meetingInfo.timer_type ? this.timeNum : 86400
        };
        questionOnly
          .post("/xcx/ques/v1/meeting/timer/start", data)
          .then(res => {
            if (res.sta == 0) {
              resolve(res);
            } else if (res.sta == -500) {
              reLogin();
            } else {
              Dialog.alert({
                message: res.msg + JSON.stringify(data)
              });
            }
          });
      });
    },
    handleTimer(type) {
      let { timer_type, timer_id } = this.meetingInfo;
      return new Promise(resolve => {
        questionOnly
          .post("/xcx/ques/v1/meeting/timer/update", {
            access_token: getToken(),
            open_id: this.userInfo.openId,
            meet_id: this.meetingInfo.meet_id,
            update_type: 0,
            status: type,
            expend_time: timer_type
              ? this.countdownTime[0] * 60 +
                this.countdownTime[1] * 1 -
                this.timeNum
              : this.timeNum,
            timer_id,
            t_update: getUTCTime()
          })
          .then(res => {
            if (res.sta == 0) {
              resolve(res);
            } else if (res.sta == -500) {
              reLogin();
            } else {
              Toast(res.msg);
            }
          });
      });
    }
  },
  destroyed() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
    if (finishTimer) {
      clearTimeout(finishTimer);
      finishTimer = null;
    }
    if (this.meetingInfo.roleType == 1 || this.meetingInfo.status == 2) {
      window.removeEventListener("popstate", this.disableBrowserBack, false);
    }
  }
};
</script>
<style lang="scss" scoped>
@function rem($px) {
  @return $px / 75 + rem;
}
.timer-wrapper {
  width: 100vw;
  max-width: 414px;
  margin: 0 auto;
  min-height: 100vh;
  background: #fff;
  position: relative;
  .positive-time {
    font-weight: 700;
    font-size: 60px;
    line-height: 90px;
    letter-spacing: 4px;
    text-align: center;
    &.active {
      color: #999999;
    }
  }
}

.set-box {
  display: flex;
  justify-content: center;
  // margin-top: 145px;
  font-size: 15px;
  color: #999;
}
.setItem input {
  width: 56px;
  min-height: 50px;
  line-height: 50px;
  font-weight: 700;
  font-size: 43px;
  text-align: center;
  display: inline;
  border: none;
  border-bottom: 3px solid #262626;
  margin-bottom: 50px;
  color: #262626;
  margin-right: 10px;
}
.setItem:last-child span {
  margin-right: 0;
}
.setItem span {
  position: relative;
  top: -20px;
  font-size: 15px;
  margin-right: 10px;
}
.choose-box {
  .title {
    font-size: 15px;
    line-height: 22px;
    color: #999999;
    margin-bottom: 10px;
  }
}
.negative-show {
  display: flex;
  justify-content: center;
  .circle-text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    // background: red;
    .c-time {
      font-weight: 700;
      font-size: 43px;
      line-height: 32px;
      margin-bottom: 12px;
      margin-top: 32px;
      &.active {
        color: #999;
      }
    }
    .t-time {
      font-size: 14px;
      line-height: 21px;
      color: #999;
    }
  }
}
.chooseList {
  display: flex;
  justify-content: space-between;
  align-items: center;

  color: #262626;
  .choose-item {
    line-height: 23px;
    background: #f2f2f7;
    border-radius: 15px;
    padding: 3px 10px;
    cursor: pointer;
    font-size: 12px;
    margin-right: 15px;
    .number {
      font-size: 15px;
      font-weight: 700;
    }
    &.active {
      background: #1890ff;
      color: #ffffff;
    }
    &:last-child {
      margin-right: 0;
    }
  }
}
.footer {
  text-align: center;
  position: absolute;
  bottom: 30px;
  left: 15px;
  right: 15px;
  .tips {
    font-size: 14px;
    line-height: 21px;
    color: #999;
    margin: 15px 0;
  }
  .center-btn {
    flex: 1;
    padding: 10px 0;
    background: #1890ff;
    border-radius: 25px;
    color: #fff;
    font-size: 16px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .center-btn img {
    width: 24px;
    height: 24px;
    margin-right: 8px;
  }
  .center-btn.active {
    background: #f2f2f7;
    color: #262626;
  }
  .center-btn-single {
    width: 190px;
    flex: initial;
    margin: 0 auto;
  }
  .left {
    margin-right: 15px;
  }
  .right {
    margin-left: 15px;
  }
  .left,
  .right {
    color: #999;
    font-size: 17px;
    padding: 8px 12px;
    border-radius: 25px;
    box-shadow: 0 rem(1) rem(8) rgba(0, 0, 0, 0.08);
    cursor: pointer;
  }
}
.user-title {
  font-weight: 700;
  font-size: 24px;
  line-height: 36px;
  padding: 15px;
}
.positive-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 139px);
  &.owner {
    min-height: calc(100vh - 159px);
  }
}
.negative-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 159px);
  // border: 1px solid red;
}
</style>



// WEBPACK FOOTER //
// src/pages/timer/timer.vue